import { render, staticRenderFns } from "./TextToAudio.vue?vue&type=template&id=4fa5e7b5"
import script from "./TextToAudio.vue?vue&type=script&lang=js"
export * from "./TextToAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports